import styled from 'styled-components'

const Wrapper = styled.div`
  min-height: 100vh;
  position: relative;
`

const Content = styled.div`
  position: relative;
  z-index: 2;

  @media (orientation: landscape) and (max-width: 700px) {
    padding-top: 9rem;
  }
  .wrap {
  }
`

const Logo = styled.img`
  width: 40vh;
  margin: 0 auto;
  @media (orientation: portrait) {
    width: 30vh;
  }
`

const Bg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
`

const Children = styled.div``

const Banner = styled.div`
  overflow: hidden;
  max-height: 40vh;
  .gatsby-image-wrapper {
    object-position: bottom center;
    max-height: 50vh;
  }
  @media (max-width: 800px) {
    margin-top: 4rem;
  }
`

export { Wrapper, Bg, Content, Logo, Children, Banner }
